var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceSwitchLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_",
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legend-Expanded",
    transform: "translate(-799.000000, -768.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(586.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schematic-View",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-_x2B_-Component-Copy-2",
    transform: "translate(148.000000, 593.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(4.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Fill-12_00000027578239448169612870000007685765257569070761_",
    fill: "none",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: " M6.6,28c0,4.3,3.5,7.7,7.8,7.7s7.8-3.5,7.8-7.7c0-4.3-3.5-7.8-7.8-7.8S6.6,23.7,6.6,28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.4,37.7c-5.4,0-9.8-4.4-9.8-9.7c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8 C24.2,33.3,19.8,37.7,14.4,37.7z M14.4,22.2c-3.2,0-5.8,2.6-5.8,5.8c0,3.1,2.6,5.7,5.8,5.7s5.8-2.6,5.8-5.7 C20.2,24.8,17.6,22.2,14.4,22.2z"
  }))))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.8,39.5c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8L48.6,9.9c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8L25.2,38.9 C24.8,39.3,24.3,39.5,23.8,39.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceSwitchLight);
export default __webpack_public_path__ + "static/media/device-switch-light.05edd89df7fc875e27345d4828f3d20f.svg";
export { ForwardRef as ReactComponent };